import 'babel-polyfill'
import Vue from 'vue'
import Index from 'modules'
import store from './store'
import router from './router'
import domain from './router/domain'
import axios from 'axios'
import { Message, Modal } from 'iview'

Vue.config.productionTip = false
// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.withCredentials = true
    config.url = config.url.replace(/^(?:(\w+):)?(.*)$/, (pattern, domain, url) => {
      config.baseURL = $Domain.Boot[domain || 'default']
      return url
    })
    config.headers.post['Content-Type'] = 'application/json'
    config.headers.common['token'] = window.localStorage.getItem('Authorization')
    if (config.method === 'get') {
      config.params = {
        t: new Date().getTime(),
        ...config.params
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })

Vue.prototype.$Domain = global.$Domain = domain
Vue.prototype.$Axios = global.$Axios = axios
Vue.prototype.$Message = global.$Message = Message
Vue.prototype.$Modal = Modal

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(Index)
})



// WEBPACK FOOTER //
// ./src/main.js